<template>
    <div v-select-text="value" style="width: 900px; background-color: #fff; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <img style="max-width: 600px;" src="./i1.png"/>
        <table width="100%" style="border-top: 1px solid #efefef; font-size: 16px;">
            <tbody>
            <tr>
                <td valign="top" align="left" style="padding: 15px 0; padding-right: 15px; position: relative;">
                    <div style="font-size: 26px; color: #ff6870; font-weight: bold;">Офис-менеджер</div>
                    <div style="height: 100px;">
                        ОАО Автокласс <br><span style="text-decoration: underline; color: blue;">Другие вакансии в этой компании</span>
                    </div>
                    <div style="text-align: justify;">
                        <p>
                            Компания Автокласс специализируется на производстве легковых автомобилей в России и Восточной Европе. Ранее наша компания выпускала автомобили под марками «Жигули», «Нива», «Спутник», «Самара», а теперь известен прежде всего как завод, где выпускается «Приора», «Гранта» и «Веста».
                        </p>
                        <p>
                            Наша компания ищет менеджера, административная работа которого будет состоять в поддержке работы офиса. Это важная и ответственная позиция, поскольку от организации процессов на каждом уровне зависит результат работы всей компании.
                        </p>
                        <p>
                            Нас интересует профессионал своего дела. Вы должны проявлять инициативу и адаптироваться к меняющимся обстоятельствам, при этом всегда соблюдая регулятивные соглашения и соглашения об оказании услуг нашим клиентам.
                        </p>
                        <p>
                            Прошедший отбор соискатель будет выполнять следующие обязанности.
                        </p>
                        <ul style="margin-left: 20px;">
                            <li>Управление кадрами и ведение отчетности по работе</li>
                            <li>Занесение и обновление данных в электронные таблицы.</li>
                            <li>Сверка плана и фактической работы, менеджмент</li>
                            <li>Коммуникация с сотрудниками, решение локальных проблем</li>
                        </ul>
                        <br>
                        <p>
                            Идеальный соискатель должен обладать следующими качествами.
                        </p>
                        <br>
                        <ul style="margin-left: 20px;">
                            <li>Внимательность к деталям</li>
                            <li>Способность работать автономно и проявлять инициативу</li>
                            <li>Уверенное знание общего делопроизводства, чуткость в управлении кадрами</li>
                        </ul>
                        <br>
                        <p>
                            Зарплата по договоренности, будет зависеть от опыта работы.
                        </p>
                    </div>
                </td>
                <td valign="top" width="260" style="padding-top: 15px; padding-left: 20px; border-left: 1px solid #efefef;">
                    <div style="text-align: center; background: rgba(255,121,45,0.8); color: #fff;padding: 10px;border-radius: 8px;font-weight: bold;">
                        Отправить резюме
                    </div>

                    <div style="margin-top: 25px; border: 2px solid #44ab48; padding: 8px;">
                        <div style="color: green; font-weight: bold; text-align: center;">Связанные с данной работой курсы от компании ACME</div>
                        <div style="padding: 10px; border-bottom: 1px solid #efefef;">Печать слепым методом</div>
                        <div style="padding: 10px; border-bottom: 1px solid #efefef;">Администрирование офиса</div>
                        <div style="padding: 10px;">Компьютерное программирование</div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped></style>